export default __webpack_public_path__ + "static/media/22_rastafari.e85a1031.png";